import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const smartRounds: AppRouteModule = {
  path: '/smart-rounds',
  name: 'SmartRounds',
  component: LAYOUT,
  redirect: '/smart-rounds/index',
  meta: {
    orderNo: 2,
    icon: 'tdesign:data-search',
    title: t('routes.nurse.smartRounds'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'SmartRoundsIndex',
      component: () => import('/@/views/nurse/smart-rounds/index.vue'),
      meta: {
        icon: 'tdesign:data-search',
        title: t('routes.nurse.smartRounds'),
        hideMenu: true,
      },
    },
  ],
};

export default smartRounds;
